import customStyles from "../../../../assets/styles/customStyles";

const iconStyle = { marginLeft: "10px" };
const sortIconUp = (props) => {
    const classes = customStyles();
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className={classes.sortIconUp} style={iconStyle} width="12" height="10" viewBox="0 0 12 10">
            <path data-name="Polygon 16" d="m6 0 6 10H0z" fill="#ffa539" />
        </svg>

    )
};

export default sortIconUp;